import React from 'react';
import Hero from '../components/Hero';
import OurTargetSection from '../components/OurTargetSection';
import MissionSection from '../components/MissionSection';
import ValuesSection from '../components/ValuesSection';
import GallerySection from '../components/GallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { SalaahTimesSection } from '../features/salaahTimes';

const HomePage: React.FC = () => {
  return (
    <>
      <div id="home">
        <Hero />
      </div>
      <SalaahTimesSection />
      <OurTargetSection />
      <MissionSection />
      <ValuesSection />
      <GallerySection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default HomePage;
